import {yupResolver} from "@hookform/resolvers/yup";
import {Button, Col, message, Row, Space} from "antd";
import {FormProvider, useForm} from "react-hook-form";
import {
  serviceOrderDeliverWorkFormValidationSchema,
  ServiceOrderDeliverWorkFormValues,
} from "./schema-validation";
import {ServiceOrderDeliverWorkFormEvidenceOfDeliveryUpload} from "./evidence-of-delivery-upload";
import {StoreServiceOrderDeliverWorkFormCompletedWorkLinks} from "./completed-work-links";
import {useDeliverWork} from "@/features/product-services";
import {useGetStoreServicesOrdersContext} from "../../get-orders/context";

// Product Service order status: Delivered = 13.
const DELIVERED_STATUS_ID = 13;

export function ServiceOrderDeliverWorkForm() {
  const {
    state: {selectedStoreServiceOrderInfo},
    dispatch,
  } = useGetStoreServicesOrdersContext();
  const deliverStoreServiceOrderApi = useDeliverWork();
  const formMethods = useForm<ServiceOrderDeliverWorkFormValues>({
    resolver: yupResolver(serviceOrderDeliverWorkFormValidationSchema),
    mode: "onSubmit",
    defaultValues: {
      completedWorkLinks: [
        {
          link: "",
        },
      ],
    },
  });

  function onSubmit(values: ServiceOrderDeliverWorkFormValues) {
    if (!selectedStoreServiceOrderInfo) {
      message.error("Missing ID");
      return;
    }

    deliverStoreServiceOrderApi.mutate(
      {
        transactionId: selectedStoreServiceOrderInfo.id.toString(),
        mediaUrls: values.completedWorkLinks.map((l) => ({key: l.link})),
        files: values.evidenceOfDelivery,
      },
      {
        onSuccess: () => {
          message.success("The order has been marked as delivered successfully");
          // v2 delivery response returns only the created delivery (no order),
          // so optimistically bump the selected order's status; the deliveries
          // themselves refresh via cache invalidation when the drawer reopens.
          dispatch({
            type: "set-selected-store-service-order-info",
            payload: {
              ...selectedStoreServiceOrderInfo,
              statusId: DELIVERED_STATUS_ID,
            },
          });
          dispatch({
            type: "set-active-store-service-order-drawer",
            payload: "order-info",
          });
        },
      }
    );
  }
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)} autoComplete="off">
        <Space direction="vertical" size={24} style={{display: "flex"}}>
          <StoreServiceOrderDeliverWorkFormCompletedWorkLinks />
          <ServiceOrderDeliverWorkFormEvidenceOfDeliveryUpload />
          <Row gutter={[0, 16]}>
            <Col span={24} sm={8}>
              <Button
                block
                type="primary"
                htmlType={"submit"}
                size="small"
                disabled={
                  Object.keys(formMethods.formState.errors).length > 0 ||
                  Object.values(formMethods.watch()).length < 1
                }
                loading={deliverStoreServiceOrderApi.isLoading}
              >
                Mark as delivered
              </Button>
            </Col>
          </Row>
        </Space>
      </form>
    </FormProvider>
  );
}
